module.exports = __webpack_public_path__ + "img/d19.db25db9a.png";